import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Icon, Button, List, Col, Row, Checkbox, Spin } from "ant-design-vue";
import { MediaSlot } from "@/util/enum";
import { PDFViewerPageReferencesModel, ResourceService } from "@/services/resource";
import { MediaViewerLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";

@Component({
	components: { Icon, Button, List, Row, Col, Item: List.Item, Checkbox, Spin }
})
export default class MediaViewer extends Vue {
	@Prop() mediaTypeId?: MediaSlot;
	@Prop() mediaId?: string;

	public pages: PDFViewerPageReferencesModel = {
		pageImages: [],
		pageInitialUrl: "",
		totalPages: 0,
		isDeleted: false
	};
	public imgUrl: string = "";
	public loading: boolean = false;

	mounted() {
		this.getPdfImages();
	}

	async getPdfImages() {
		this.loading = true;
		if (this.mediaTypeId === MediaSlot.Thumbnail || this.mediaTypeId === MediaSlot.Image) {
			const imgUrl = await ResourceService.getDownloadMediaUrl(this.mediaId as string);
			this.imgUrl = imgUrl;
			this.loading = false;
		} else if (
			(this.mediaTypeId === MediaSlot.ViewingContent ||
				this.mediaTypeId == MediaSlot.TeacherManual ||
				this.mediaTypeId == MediaSlot.AudioBackground) &&
			this.mediaId
		) {
			const result = await ResourceService.getPdfImages(this.mediaId);
			this.pages.pageInitialUrl = result.pageInitialUrl;
			this.pages.pageImages = result.pageImages.map(x => x);
			this.loading = false;
		}
	}

	onCheckboxChange(e, pageId) {
		this.$emit("isDirty", { isDirty: true });
		this.pages.pageImages.forEach((page) => {
			if (page.id === pageId) {
				page.teacherUseOnly = e.target.checked;
			}
		});
	}

	get isMediaAlternateContent() {
		if (this.mediaTypeId && this.mediaTypeId === MediaSlot.AlternateContent) {
			return true;
		}

		return false;
	}

	get mediaViewerLocale() {
		return MediaViewerLocale;
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
}
